<template>
  <v-container
    fluid
    class="mt-2"
    :class="
      $vuetify.breakpoint.mdAndUp
        ? 'py-5 px-10'
        : '' && $vuetify.breakpoint.smAndUp
        ? 'py-2 px-2'
        : ''
    "
  >
    <pageHeader title="Terms of Service" />

    <p v-html="html" />
  </v-container>
</template>

<script>
import pageHeader from '@/components/layout/PageHeader'
export default {
  name: 'Terms',
  components: {
    pageHeader
  },
  metaInfo: {
    title: 'Terms of Service',
    titleTemplate: '%s | LinkBook.io',
    meta: [
      {
        name: 'description',
        content:
          'These Terms of use described the legally binding terms and conditions that oversee your use of the Site.'
      }
    ]
  },
  data() {
    return {
      LinkbookName: 'LinkBook.io',
      linkparams: null,
      editmodal: false,
      html: `<div class="card-body">
      <p>Last updated: 2025-04-08</p>

      <h3>1. Introduction</h3>
      <p>Welcome to LinkBook ("Company", "we", "our", "us")!</p>
      <p>These Terms of Service ("Terms", "Terms of Service") govern your use of our website located at ${process.env.VUE_APP_HOST} (together or individually "Service") operated by LinkBook.</p>
      <p>Our Privacy Policy also governs your use of our Service and explains how we collect, safeguard and disclose information that results from your use of our web pages.</p>
      <p>Your agreement with us includes these Terms and our Privacy Policy ("Agreements"). You acknowledge that you have read and understood Agreements, and agree to be bound of them.</p>
      <p>If you do not agree with (or cannot comply with) Agreements, then you may not use the Service, but please let us know by emailing at info@linkbook.io so we can try to find a solution. These Terms apply to all visitors, users and others who wish to access or use Service.</p>

      <h3>2. Communications</h3>
      <p>By using our Service, you agree to subscribe to newsletters, marketing or promotional materials and other information we may send. However, you may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or by emailing at info@linkbook.io.</p>

      <h3>3. Purchases</h3>
      <p>If you wish to purchase any product or service made available through Service ("Purchase"), you may be asked to supply certain information relevant to your Purchase including but not limited to, your credit or debit card number, the expiration date of your card, your billing address, and your shipping information.</p>
      <p>You represent and warrant that: (i) you have the legal right to use any card(s) or other payment method(s) in connection with any Purchase; and that (ii) the information you supply to us is true, correct and complete.</p>
      <p>We may employ the use of third party services for the purpose of facilitating payment and the completion of Purchases. By submitting your information, you grant us the right to provide the information to these third parties subject to our Privacy Policy.</p>

      <h3>4. Subscriptions</h3>
      <p>Some parts of Service are billed on a subscription basis ("Subscription(s)"). You will be billed in advance on a recurring and periodic basis ("Billing Cycle"). Billing cycles will be set depending on the type of subscription plan you select when purchasing a Subscription.</p>
      <p>At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions unless you cancel it or LinkBook cancels it. You may cancel your Subscription renewal either through your online account management page or by contacting info@linkbook.io customer support team.</p>

      <h3>5. Free Trial</h3>
      <p>LinkBook may, at its sole discretion, offer a Subscription with a free trial for a limited period of time ("Free Trial").</p>
      <p>You may be required to enter your billing information in order to sign up for Free Trial.</p>
      <p>If you do enter your billing information when signing up for Free Trial, you will not be charged by LinkBook until Free Trial has expired. On the last day of Free Trial period, unless you cancelled your Subscription, you will be automatically charged the applicable Subscription fees for the type of Subscription you have selected.</p>

      <h3>6. Content</h3>
      <p>Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material ("Content"). You are responsible for Content that you post on or through Service, including its legality, reliability, and appropriateness.</p>
      <p>By posting Content on or through Service, You represent and warrant that: (i) Content is yours (you own it) and/or you have the right to use it and the right to grant us the rights and license as provided in these Terms, and (ii) that the posting of your Content on or through Service does not violate the privacy rights, publicity rights, copyrights, contract rights or any other rights of any person or entity.</p>

      <h3>7. Prohibited Uses</h3>
      <p>You may use Service only for lawful purposes and in accordance with Terms. You agree not to use Service:</p>
      <ul>
        <li>In any way that violates any applicable national or international law or regulation.</li>
        <li>For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way.</li>
        <li>To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail", "chain letter," "spam," or any other similar solicitation.</li>
        <li>To impersonate or attempt to impersonate Company, a Company employee, another user, or any other person or entity.</li>
      </ul>

      <h3>8. Analytics</h3>
      <p>We may use third-party Service Providers to monitor and analyze the use of our Service.</p>

      <h3>9. Accounts</h3>
      <p>When you create an account with us, you guarantee that you are of legal age to form a binding contract in your jurisdiction, and that the information you provide us is accurate, complete, and current at all times. Please refer to this section regarding minimum age requirements for using our Service. Inaccurate, incomplete, or obsolete information may result in the immediate termination of your account on Service.</p>

      <h3>10. Intellectual Property</h3>
      <p>Service and its original content (excluding Content provided by users), features and functionality are and will remain the exclusive property of LinkBook and its licensors. Service is protected by copyright, trademark, and other laws of and foreign countries. Our trademarks may not be used in connection with any product or service without the prior written consent of LinkBook.</p>

      <h3>11. Copyright Policy</h3>
      <p>We respect the intellectual property rights of others. It is our policy to respond to any claim that Content posted on Service infringes on the copyright or other intellectual property rights ("Infringement") of any person or entity.</p>

      <h3>12. Error Reporting and Feedback</h3>
      <p>You may provide us either directly at info@linkbook.io or via third party sites and tools with information and feedback concerning errors, suggestions for improvements, ideas, problems, complaints, and other matters related to our Service ("Feedback").</p>

      <h3>13. Disclaimer Of Warranty</h3>
      <p>THESE SERVICES ARE PROVIDED BY COMPANY ON AN "AS IS" AND "AS AVAILABLE" BASIS. COMPANY MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THEIR SERVICES, OR THE INFORMATION, CONTENT OR MATERIALS INCLUDED THEREIN.</p>

      <h3>14. Contact Us</h3>
      <p>Please send your feedback, comments, requests for technical support by email: info@linkbook.io</p>

      <h3>15. Accept</h3>
      <p>By creating an account and using the services that ${process.env.VUE_APP_HOST} provide, you accept These Terms of Service.</p>

      <p class="mt-4">Effective date: 2025-04-08</p>
      <p>© 2025 LinkBook - All rights reserved</p>
      </div>`
    }
  }
}
</script>
